import React, { Component } from 'react';
import { Grid, Button, Typography, Box, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Select } from '@material-ui/core';
import '../CSS/NewReservation.css';
import { getTaxes, getEmailTemplates, getEmails, getCampers, getGroups, createnewCamper, createNewGroup, createGroupReservations, getSiteTaxes, getIntegrations, addGroupSystemFeeRecord, getVariableRatesStatus, saveGroupResevationCharges } from '../utils/OpenCampground_Database_Calls'
import TextField from '@mui/material/TextField';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import reservationConfirmation from '../assets/reservation_confirm.png'
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import GroupIcon from '@mui/icons-material/Group';
import PetsIcon from '@mui/icons-material/Pets';
import DateRangeIcon from '@mui/icons-material/DateRange';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Autocomplete, createFilterOptions } from '@mui/material';
import { format, differenceInCalendarDays, addDays, isBefore, isAfter, min, max } from 'date-fns';
import dayjs from "dayjs";

const useStyles = theme => ({
    dialogPaper: {
        padding: theme.spacing(2),
        borderRadius: '10px',
    }
});

const theme = createTheme({
    palette: {
        primary: {
            main: '#2dcd7a',
        },
    }
});

const toUTCDateOnly = function(dateString) {
    const [year, month, day] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day);
  };
const offsetMinutes = new Date().getTimezoneOffset();

class GroupReservationUserDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allGuests: [],
            //wagon Master details
            fname: [''],
            lname: [''],
            emailId: [''],
            phoneNumber: [''],
            address: [''],
            city: [''],
            state: [''],
            zip: [''],
            guests: [''],
            pets: [''],
            childrens: [''],
            camperId: [''],
            //group
            groupName: '',
            groupId: '',
            groups: [],
            //taxes
            taxes: [],
            tax: [],
            taxPercent: [],
            taxName: [],
            //total
            totalAmount: [],
            subTotal: [],
            monthsTotal: [],
            weeksTotal: [],
            daysTotal: [],
            discountTotal: [],
            days: '',
            weeks: '',
            months: '',
            //popup
            open: false,
            popupText: '',
            openGroupModal: false,
            wait: false,
            //email
            remoteResReceivedMailMessage: '',
            remoteReservationReceivedSubject: '',
            sender: '',
            reply: '',
            cc: '',
            bcc: '',
            selectedSpaceIndex: 1,
            formValid: false,
            groupIDS: [],
            spaceName: [],
            siteIds: [],
            //integration
            paymentIntegration: [],
            daySpecificRatesStatus :'',
            dayChunks: [],
            chargesArray: [[]]
        };
    }

    async componentDidMount() {
        console.log("spaceDate: ", this.props.spacesSelected)
        this.getGuests()
        let getGroupsResponse = await getGroups(this.props.user, this.props.serverName)
        let mailMessages = await getEmailTemplates(this.props.user, this.props.serverName)
        let email = await getEmails(this.props.user, this.props.serverName)
        let paymentIntegration = await getIntegrations(this.props.user, this.props.serverName)
        const daySpecificRatesStatus = await getVariableRatesStatus(this.props.user, this.props.serverName)

        //calculate total
        let term = this.getDuration(this.props.checkIn, this.props.checkOut);
        let daysDiscountTotalArray = [];
        let weeksDiscountTotalArray = [];
        let monthsDiscountTotalArray = [];
        let chargesArray = [];
        let subTotalArray = [];
        let discountTotalArray = [];
        let monthsTotalArray = [];
        let weeksTotalArray = [];
        let daysTotalArray = [];
        let siteTypeIdArray = [];
        let n = this.props.spacesSelected.length;
        this.setState({
            fname: Array(n).fill(""),
            lname: Array(n).fill(""),
            emailId: Array(n).fill(""),
            phoneNumber: Array(n).fill(""),
            address: Array(n).fill(""),
            city: Array(n).fill(""),
            state: Array(n).fill(""),
            zip: Array(n).fill(""),
            guests: Array(n).fill(""),
            pets: Array(n).fill(""),
            childrens: Array(n).fill(""),
            camperId: Array(n).fill(""),
        })
        this.props.spacesSelected.forEach((space, i) => {
            let seasons = this.props.spaceSpecificRates[i];
            // let monthDate = new Date(this.props.checkIn);
            let monthDate = offsetMinutes > 0? toUTCDateOnly(this.props.checkIn): new Date(this.props.checkIn);
            let subTotal = 0.0;
            let monthsTotal = 0;
            let weeksTotal = 0;
            let daysTotal = 0;
            let discountTotal = null;
            let siteTypeId = space.siteTypeId;
            let monthChunks = [];
            let weekChunks = [];
            let dayChunks = [];
            let charges = [];
            let monthsDiscountTotal = 0;
            let weeksDiscountTotal = 0;
            let daysDiscountTotal = 0;
            const daySpecificRates = {
                0: space.sunday,
                1: space.monday,
                2: space.tuesday,
                3: space.wednesday,
                4: space.thursday,
                5: space.friday,
                6: space.saturday
              };

            // if (term[2] > 0) {
            //     if (space.monthly > 0) {
            //         monthsTotal = term[2] * space.monthly;
            //         subTotal += monthsTotal;
            //     } else {
            //         let totalDaysFromMonths = 0;
            //         for (let i = 0; i < term[2]; i++) {
            //             let monthDate = new Date(this.props.checkIn);
            //             monthDate.setMonth(monthDate.getMonth() + i);
            //             const monthDays = new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 0).getDate();
            //             totalDaysFromMonths += monthDays;
            //         }
            //         // term[1] += term[2] * 4;
            //         const weeksFromMonths = Math.floor(totalDaysFromMonths / 7);
            //         const leftoverDays = totalDaysFromMonths % 7;
            //         term[1] += weeksFromMonths;
            //         term[0] += leftoverDays;
            //         term[2] = 0;
            //     }
            // }
            // if (term[1] > 0) {
            //     if (space.weekly > 0) {
            //         weeksTotal = term[1] * space.weekly;
            //         subTotal += weeksTotal;
            //     } else {
            //         term[0] += term[1] * 7;
            //         term[1] = 0;
            //     }
            // }
            // if (term[0] > 0) {
            //     if(daySpecificRatesStatus){
            //         let checkInDate = new Date(this.props.checkIn);
            //         let daysToAdvance = 0;
            //         let baseDate = new Date(this.props.checkIn);
            //         for (let i = 0; i < term[2]; i++) {
            //             let monthDate = new Date(baseDate);
            //             monthDate.setMonth(monthDate.getMonth() + i);
            //             let year = monthDate.getFullYear();
            //             let month = monthDate.getMonth();
            //             let daysInMonth = new Date(year, month + 1, 0).getDate();
            //             daysToAdvance += daysInMonth;
            //         }
            //         checkInDate.setDate(checkInDate.getDate() + daysToAdvance);
            //         for (let i = 0; i < term[0]; i++) {
            //             const dayOfWeek = checkInDate.getUTCDay();
            //             console.log('the day of thee week', dayOfWeek);
            //             const dayspecificrate = daySpecificRates[dayOfWeek] ?? this.props.daily ?? 0;
            //             console.log(`the day of thee week ${dayOfWeek} and its price ${dayspecificrate} ${this.props.sunday} ${this.props.Saturday}`);
            //             daysTotal += dayspecificrate;
            //             subTotal += dayspecificrate;
            //             checkInDate.setDate(checkInDate.getDate() + 1);
            //         }}
            //         else{
            //         daysTotal = (Math.round(term[0]) * space.daily);
            //         subTotal += daysTotal;
            //         }
            // }
            if(term[2]){
                let monthEndDate = new Date(monthDate);
                monthEndDate.setMonth(monthEndDate.getMonth() + term[2]);
                // monthDate.setMonth(monthDate.getMonth() + term[2]); 
                monthChunks = this.calculateReservationCost(monthDate, monthEndDate, seasons, term[2])
                monthsTotal = monthChunks.monthsTotal;
                subTotal += monthChunks.monthsTotal;
                monthDate.setMonth(monthDate.getMonth() + term[2]);
                console.log(JSON.stringify(monthChunks));
            }
            if(term[1]){
                let weekEndDate = new Date(monthDate);
                weekEndDate.setDate(monthDate.getDate() + term[1] * 7);
                weekChunks = this.calculateWeeklyReservationCost(monthDate, weekEndDate, seasons)
                weeksTotal = weekChunks.weeksTotal
                subTotal += weekChunks.weeksTotal;
                monthDate.setDate(monthDate.getDate() + term[1] * 7);
                console.log(JSON.stringify(weekChunks));
            }
            if(term[0]){
                let endDate = new Date(this.props.checkOut);
                dayChunks = this.calculateDailyReservationCost(monthDate, endDate, seasons, daySpecificRatesStatus)
                daysTotal = dayChunks.daysTotal;
                subTotal += dayChunks.daysTotal;
                console.log(JSON.stringify(dayChunks));
            }
            let {monthCharges, weekCharges, dayCharges} = this.transformChunks(monthChunks?.chunks, weekChunks?.chunks, dayChunks?.chunks);
            charges = [...monthCharges, ...weekCharges, ...dayCharges];

            if (this.props.discount != null) {
                if (this.props.discountAmountOnce > 0) {
                    discountTotal = this.props.discountAmountOnce
                    charges = [...monthCharges, ...weekCharges, ...dayCharges];
                    charges[0].discount = this.props.discountAmountOnce;
                } else if (this.props.discountAmountDaily > 0 || this.props.discountAmountWeekly > 0 || this.props.discountAmountMonthly > 0) {
                    if (term[2] > 0 && this.props.discountAmountMonthly > 0) {
                        discountTotal += (term[2] * this.props.discountAmountMonthly)
                        monthCharges = monthCharges.map((monthcharge)=> ({...monthcharge,discount:monthcharge.period*this.props.discountAmountMonthly}))
                        monthsDiscountTotal = term[2] * this.props.discountAmountMonthly;
                    }
                    if (term[1] > 0 && this.props.discountAmountWeekly > 0) {
                        discountTotal += (term[1] * this.props.discountAmountWeekly)
                        weekCharges = weekCharges.map((weekcharge)=> ({...weekcharge,discount:weekcharge.period*this.props.discountAmountWeekly}))
                        weeksDiscountTotal = term[1] * this.props.discountAmountWeekly;
                    }
                    if (term[0] > 0 && this.props.discountAmountDaily > 0) {
                        discountTotal += (term[0] * this.props.discountAmountDaily)
                        dayCharges = dayCharges.map((daycharge)=> ({...daycharge,discount:this.props.discountAmountDaily}))
                        daysDiscountTotal = term[0] * this.props.discountAmountDaily;
                    }
                    charges = [...monthCharges, ...weekCharges, ...dayCharges];
                } else {
                    if (monthsTotal > 0 && this.props.monthlyDiscount) {
                        discountTotal += (monthsTotal * this.props.discountPercent) / 100
                        monthCharges = monthCharges.map((monthcharge)=> ({...monthcharge,discount:(monthcharge.amount*this.props.discountPercent)/100}))
                        monthsDiscountTotal = (monthsTotal * this.props.discountPercent) / 100;
                    }
                    if (weeksTotal > 0 && this.props.weeklyDiscount) {
                        discountTotal += (weeksTotal * this.props.discountPercent) / 100
                        weekCharges = weekCharges.map((weekcharge)=> ({...weekcharge,discount:(weekcharge.amount*this.props.discountPercent)/100}))
                        weeksDiscountTotal = (weeksTotal * this.props.discountPercent) / 100;
                    }
                    if (daysTotal > 0 && this.props.dailyDiscount) {
                        discountTotal += (daysTotal * this.props.discountPercent) / 100
                        dayCharges = dayCharges.map((daycharge)=> ({...daycharge,discount:(daycharge.amount*this.props.discountPercent)/100}))
                        daysDiscountTotal = (daysTotal * this.props.discountPercent) / 100;
                    }
                    this.setState({
                        discountByPercent: true
                    })
                    charges = [...monthCharges, ...weekCharges, ...dayCharges];
                }
                subTotal -= discountTotal
            }
            chargesArray.push(charges)
            monthsDiscountTotalArray.push(monthsDiscountTotal)
            weeksDiscountTotalArray.push(weeksDiscountTotal);
            daysDiscountTotalArray.push(daysDiscountTotal);

            subTotalArray.push(subTotal);
            monthsTotalArray.push(monthsTotal);
            weeksTotalArray.push(weeksTotal);
            daysTotalArray.push(daysTotal);
            siteTypeIdArray.push(siteTypeId)
            discountTotalArray.push(discountTotal)
            this.setState({
                dayChunks: [],
            })
        });
        this.calculateTaxAndTotal(subTotalArray, term, siteTypeIdArray);
        this.setState({
            groups: getGroupsResponse.body,
            subTotal: subTotalArray,
            monthsTotal: monthsTotalArray,
            weeksTotal: weeksTotalArray,
            daysTotal: daysTotalArray,
            discountTotal: discountTotalArray,
            days: term[0],
            weeks: term[1],
            months: term[2],
            remoteResReceivedMailMessage: mailMessages[3].body,
            remoteReservationReceivedSubject: email.remote_res_subject,
            sender: email.sender,
            reply: email.reply,
            cc: email.cc,
            bcc: email.bcc,
            siteIds: this.props.spacesSelected.map(item => item.siteId),
            spaceName: this.props.spacesSelected.map(item => item.spaceName),
            paymentIntegration: paymentIntegration,
            daySpecificRatesStatus: daySpecificRatesStatus,
            chargesArray: chargesArray
        })
    }

    calculateTaxAndTotal = async (subTotalArray, term, siteTypeIdArray) => {
        let taxes = await getTaxes(this.props.user, this.props.serverName);
        let totalAmountArray = [];
        let taxArray = [];
        let taxPercentArray = [];
        let taxNameArray = [];
        const selectedTaxesIdArray = await Promise.all(
            siteTypeIdArray.map(async (sitetype_id) => {
              let selectedTaxes = await getSiteTaxes(this.props.user, this.props.serverName, sitetype_id);
              return selectedTaxes[0]?.taxrate_ids 
                ? selectedTaxes[0].taxrate_ids.split(',').map(id => Number(id.trim())) 
                : [];
            })
          );
          console.log(JSON.stringify(selectedTaxesIdArray)+'taxes for the sites');

        subTotalArray.forEach((subTotal, index) => {
            let totalAmount = subTotal;
            let tax = [];
            let taxPercent = [];
            let taxName = [];
            let selectedTaxesforSite = selectedTaxesIdArray[index]

            for (let index = 0; index < taxes.length; index++) {
                if(!selectedTaxesforSite.includes(taxes[index].id))
                    continue;
                const element = taxes[index];
                if (element.is_percent === 1) {
                    if (element.apl_daily === 0 && element.apl_week === 0 && element.apl_month === 0) {
                        console.log("No tax");
                    } else if (element.apl_daily === 1) {
                        taxPercent.push(element.percent);
                        tax.push((subTotal * (element.percent / 100)).toFixed(2));
                        taxName.push(element.name);
                    }
                } else {
                    let totalDays = term[0];
                    if (element.apl_month === 1) {
                        if (element.monthly_charge_daily === 1) {
                            totalDays = totalDays + term[2] * 30;
                        } else {
                            taxPercent.push(element.amount);
                            tax.push((term[2] * element.amount).toFixed(2));
                            taxName.push(element.name);
                        }
                    } else if (element.apl_week === 1) {
                        if (element.weekly_charge_daily === 1) {
                            totalDays = totalDays + term[1] * 7;
                        } else {
                            taxPercent.push(element.amount);
                            tax.push((term[1] * element.amount).toFixed(2));
                            taxName.push(element.name);
                        }
                    }
                    taxPercent.push(element.amount);
                    tax.push((totalDays * element.amount).toFixed(2));
                    taxName.push(element.name);
                }
            }

            for (let index = 0; index < tax.length; index++) {
                totalAmount += parseFloat(tax[index]);
            }

            totalAmountArray.push(totalAmount);
            taxArray.push(tax);
            taxPercentArray.push(taxPercent);
            taxNameArray.push(taxName);
        });

        this.setState({
            taxes: taxes,
            totalAmount: totalAmountArray,
            tax: taxArray,
            taxPercent: taxPercentArray,
            taxName: taxNameArray,
        });
    };

    formatDate(dateStr) {
        // return new Date(dateStr).toISOString().split("T")[0];
        return dayjs(dateStr).format("YYYY-MM-DD");
    }
      
    transformChunks(monthChunks, weekChunks, dayChunks) {
        const result = [];
        const monthCharges = [];
        const weekCharges = [];
        const dayCharges = []
      
        // Months
        monthChunks?.forEach(c => {
            monthCharges.push({
            start_date: this.formatDate(c.from),
            end_date: this.formatDate(c.to),
            period: c.months,
            rate: c.rate,
            amount: c.cost,
            discount: c.discount,
            charge_unit: 2,
            seasonId: c.seasonId
          });
        });
      
        // Weeks
        weekChunks?.forEach(c => {
          weekCharges.push({
            start_date: this.formatDate(c.from),
            end_date: this.formatDate(c.to),
            period: c.weeks,
            rate: c.rate,
            amount: c.cost,
            discount: c.discount,
            charge_unit: 1,
            seasonId: c.seasonId
          });
        });
      
        // Days
        dayChunks?.forEach(c => {
          dayCharges.push({
            start_date: this.formatDate(c.from),
            end_date: this.formatDate(c.to),
            period: 1,
            rate: c.rate,
            amount: c.cost,
            discount: c.discount,
            charge_unit: 0,
            seasonId: c.seasonId
          });
        });
      
        return {monthCharges, weekCharges, dayCharges};
    }

    getGuests = async () => {
        try {
            let listOfGuests = await getCampers(this.props.user, this.props.serverName);
            this.setState({
                allGuests: listOfGuests
            });
        } catch (error) {
            console.error("Error fetching guests:", error);
        }
    }

    getAverageMonthDays(from, to, monthsCount) {
        const fromDate = new Date(from);
        
        // If only one month, return the number of days in the 'from' month
        if (monthsCount <= 1) {
          const year = fromDate.getFullYear();
          const month = fromDate.getMonth();
          return new Date(year, month + 1, 0).getDate();
        }
      
        // Otherwise, calculate the average days per month in the range
        let totalMonthDays = 0;
        let count = 0;
        let current = new Date(fromDate);
      
        while (current < to) {
          const year = current.getFullYear();
          const month = current.getMonth();
          const daysInMonth = new Date(year, month + 1, 0).getDate();
      
          totalMonthDays += daysInMonth;
          count++;
      
          // Move to next month
          current = new Date(year, month + 1, 1);
        }
      
        return count > 0 ? totalMonthDays / count : 30;
      }

    calculateReservationCost(reservationStart, reservationEnd, seasons, monthsCount) {
        let monthsTotal = 0;
        seasons =  seasons.filter(s => s.applies_to_monthly);
        const boundaries = new Set();
      
        // Ensure all dates are Date objects
        reservationStart = new Date(reservationStart);
        reservationEnd = new Date(reservationEnd);
      
        // Find boundaries based on season overlaps
        seasons.forEach(season => {
          const start = new Date(season.season_start);
          const end = addDays(new Date(season.season_end), 1); // inclusive
      
          if (isBefore(end, reservationStart) || isAfter(start, reservationEnd)) return;
      
          boundaries.add(max([reservationStart, start]).toISOString().split('T')[0]);
          boundaries.add(min([reservationEnd, end]).toISOString().split('T')[0]);
        });
      
        // Add reservation start and end to ensure full coverage
        boundaries.add(reservationStart.toISOString().split('T')[0]);
        boundaries.add(reservationEnd.toISOString().split('T')[0]);
      
        const sortedBoundaries = Array.from(boundaries)
          .map(d => offsetMinutes > 0? toUTCDateOnly(d):new Date(d))
          .sort((a, b) => a - b);
      
        const chunks = [];
      
        for (let i = 0; i < sortedBoundaries.length - 1; i++) {
          const from = sortedBoundaries[i];
          const to = sortedBoundaries[i + 1];
      
          if (differenceInCalendarDays(to, from) <= 0) continue;
      
          const applicableSeasons = seasons.filter(season => {
            const seasonStart = new Date(season.season_start);
            const seasonEndInclusive = addDays(new Date(season.season_end), 1);
            return from < seasonEndInclusive && to > seasonStart;
          });
      
          const season = applicableSeasons.sort(
            (a, b) =>
              (new Date(a.season_end) - new Date(a.season_start)) -
              (new Date(b.season_end) - new Date(b.season_start))
          )[0] || seasons.find(s => s.season_id === 1); // fallback
      
          const days = differenceInCalendarDays(to, from);
        //   const months = days / 30;
          const avgMonthDays = this.getAverageMonthDays(from, to, monthsCount);
          const months = sortedBoundaries.length > 2 ? days / avgMonthDays : monthsCount;
          const cost = parseFloat((months * season.monthly_rate).toFixed(2));
          monthsTotal += cost;

          if(cost == 0){
            this.setState({
                dayChunks: [...this.state.dayChunks, {from:from,to:to,days:days,seasonName:season.season_name,seasonId:season.season_id}]
            })
          }
          else{
            chunks.push({
                from,
                to,
                days,
                months: months.toFixed(3),
                season: season.season_name,
                cost,
                seasonId: season.season_id,
                charge_unit: 2,
                discount: 0,
                rate:season.monthly_rate
            });
          }
        }
      
        return {chunks, monthsTotal};
      }

    calculateWeeklyReservationCost(reservationStart, reservationEnd, seasons) {
        console.log(reservationStart, reservationEnd);
        let weeksTotal = 0;
        seasons =  seasons.filter(s => s.applies_to_weekly);
        const boundaries = new Set();
      
        seasons.forEach(season => {
          const start = new Date(season.season_start);
          const end = new Date(season.season_end);
          if (isBefore(end, reservationStart) || isAfter(start, reservationEnd)) return;
      
          boundaries.add(max([reservationStart, start]).toISOString().split('T')[0]);
          boundaries.add(min([reservationEnd, new Date(end.getTime() + 86400000)]).toISOString().split('T')[0]); // inclusive
        });
      
        boundaries.add(reservationStart.toISOString().split('T')[0]);
        boundaries.add(reservationEnd.toISOString().split('T')[0]);
      
        const sortedBoundaries = Array.from(boundaries).sort();
        const chunks = [];
      
        for (let i = 0; i < sortedBoundaries.length - 1; i++) {
        //   const from = new Date(sortedBoundaries[i]);
        //   const to = new Date(sortedBoundaries[i + 1]);
        const from = offsetMinutes > 0? toUTCDateOnly(sortedBoundaries[i]):new Date(sortedBoundaries[i]);
        const to = offsetMinutes > 0? toUTCDateOnly(sortedBoundaries[i+1]):new Date(sortedBoundaries[i+1]);
          if (differenceInCalendarDays(to, from) <= 0) continue;

        //   const applicableSeasons = seasons.filter(season => {
        //     const seasonStart = new Date(season.season_start);
        //     const seasonEnd = new Date(season.season_end);
        //     return from <= seasonEnd && to >= seasonStart; // Overlap allowed
        //   }); 
        const applicableSeasons = seasons.filter(season => {
            const seasonStart = new Date(season.season_start);
            const seasonEndInclusive = addDays(new Date(season.season_end), 1);
            return from < seasonEndInclusive && to > seasonStart;
        });
          
          const season = applicableSeasons.sort((a, b) =>
            (new Date(a.season_end) - new Date(a.season_start)) -
            (new Date(b.season_end) - new Date(b.season_start))
          )[0] || seasons.find(s => s.season_id === 1);
      
          const days = differenceInCalendarDays(to, from);
          const weeks = days / 7;
          const cost = parseFloat((weeks * season.weekly_rate).toFixed(2));
          weeksTotal += cost;

          if(cost == 0){
            this.setState({
                dayChunks: [...this.state.dayChunks, {from:from,to:to,days:days,seasonName:season.season_name,seasonId:season.season_id}]
            })
          }
          else{
            chunks.push({
                from,
                to,
                days,
                weeks: weeks.toFixed(3),
                season: season.season_name,
                cost,
                seasonId: season.season_id,
                charge_unit: 1,
                discount: 0,
                rate:season.weekly_rate,
            });
          }
        }
      
        return {chunks, weeksTotal};
      }

    calculateDailyReservationCost(reservationStart, reservationEnd, seasons, daySpecificRatesStatus) {
        const chunks = [];
        console.log(this.state.dayChunks);
        let daysTotal = 0;
      
        this.state.dayChunks.forEach(chunk => {
          let currentDate = new Date(chunk.from);
          const toDate = new Date(chunk.to);
          const season = seasons.find(s => s.season_id === chunk.seasonId);
          if (!season) return;
      
          while (currentDate < toDate) {
            const nextDate = addDays(currentDate, 1);
            const dayIndex = currentDate.getDay();
            const dayMap = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
      
            let cost = daySpecificRatesStatus ? (season[dayMap[dayIndex]] || 0) : (season.daily_rate || 0);
            daysTotal += cost;
      
            chunks.push({
              from: new Date(currentDate),
              to: new Date(nextDate),
              day: currentDate.toDateString(),
              season: season.season_name,
              cost,
              seasonId: season.season_id,
              charge_unit: 0,
              discount: 0,
              rate:cost
            });
      
            currentDate = nextDate;
          }
        });
      
        // Now handle main direct range
        let currentDate = new Date(reservationStart);
        const endDate = new Date(reservationEnd);
      
        while (currentDate < endDate) {
          const nextDate = addDays(currentDate, 1);
      
          const applicableSeasons = seasons.filter(season =>
            currentDate >= new Date(season.season_start) && currentDate <= new Date(season.season_end)
          );
      
          let season = applicableSeasons.sort(
            (a, b) =>
              (new Date(a.season_end) - new Date(a.season_start)) -
              (new Date(b.season_end) - new Date(b.season_start))
          )[0] || seasons.find(s => s.season_id === 1);
      
          const dayIndex = currentDate.getDay();
          const dayMap = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
      
          let cost = daySpecificRatesStatus ? (season[dayMap[dayIndex]] || 0) : (season.daily_rate || 0);
          daysTotal += cost;
      
          chunks.push({
            from: new Date(currentDate),
            to: new Date(nextDate),
            day: currentDate.toDateString(),
            season: season.season_name,
            cost,
            seasonId: season.season_id,
            charge_unit: 0,
            discount: 0,
            rate:cost
          });
      
          currentDate = nextDate;
        }
      
        return {chunks, daysTotal};
    }

    // getDuration(checkIn, checkOut) {
    //     const msPerDay = 24 * 60 * 60 * 1000;
    //     const msPerWeek = msPerDay * 7;
    //     const startDate = new Date(checkIn);
    //     const endDate = new Date(checkOut);
    //     let totalDays = Math.floor((endDate - startDate) / msPerDay);
    //     const months = Math.floor(totalDays / 30);
    //     totalDays %= 30;
    //     const weeks = Math.floor(totalDays / 7);
    //     totalDays %= 7;
    //     const days = totalDays;
    //     return [days, weeks, months];
    // }
    
    toUTCDateOnly = (dateString) => {
        const date = new Date(dateString);
        return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
    }

    getDuration(checkIn, checkOut) {
        const startDate = this.toUTCDateOnly(checkIn);
        const endDate = this.toUTCDateOnly(checkOut);
        let months = 0, weeks = 0, days = 0;
        let tempDate = new Date(startDate);
        while (true) {
            const nextMonth = new Date(Date.UTC(tempDate.getUTCFullYear(), tempDate.getUTCMonth() + 1, tempDate.getUTCDate()));
            if (nextMonth <= endDate) {
                months++;
                tempDate = nextMonth;
            } else {
                break;
            }
        }
        const remainingDays = Math.floor((endDate - tempDate) / (24 * 60 * 60 * 1000));
        weeks = Math.floor(remainingDays / 7);
        days = remainingDays % 7;
        return [days, weeks, months];
    }

    getDays = () => {
        const msPerDay = 24 * 60 * 60 * 1000;
        const startDate = new Date(this.props.checkIn);
        const endDate = new Date(this.props.checkOut);
        let totalDays = Math.floor((endDate - startDate) / msPerDay);
        return totalDays;
    }

    handleCancel = () => {
        if (!this.state.wait) {
            this.setState({ open: false }, () => {
                this.props.history.replace(`/manager?serverName=${this.props.serverName}&view=reservations`);
            });
        }
    }

    userDetailsChange = (id, value, index) => {
        if (id === 'groupName') {
            this.setState({
                groupName: value
            }, () => {
                this.dataValidation()
            })
        } else {
            let finalValue
            if (id === 'phoneNumber' || id === 'guests' || id === 'childrens' || id === 'pets') {
                finalValue = value.replace(/[^0-9]/g, '')
            } else {
                finalValue = value
            }
            this.setState((prevState) => {
                const updatedArray = [...prevState[id]];
                if (updatedArray.length <= index) {
                    updatedArray.length = index + 1;
                    updatedArray[index] = '';
                }
                updatedArray[index] = finalValue;

                return {
                    [id]: updatedArray,
                };
            }, () => {
                this.dataValidation();
            });
        }
    };

    dataValidation = async () => {
        const len = this.props.spacesSelected.length;
        const fieldsToMatchLength = ['fname', 'lname', 'guests', 'childrens', 'pets'];
        const fieldsWithAtLeastZeroIndex = [
            'emailId', 'phoneNumber', 'address', 'city', 'state', 'zip'
        ];
        const areLengthFieldsValid = fieldsToMatchLength.every((field) => {
            const fieldArray = this.state[field];
            return (
                fieldArray.length === len &&
                fieldArray.every((entry) => entry.trim() !== '')
            );
        });
        const areZeroIndexFieldsValid = fieldsWithAtLeastZeroIndex.every((field) => {
            const fieldArray = this.state[field];
            return fieldArray[0]?.trim() !== '';
        });
        const isGroupNameValid = this.state.groupName.trim() !== '';
        this.setState({
            formValid: areLengthFieldsValid && areZeroIndexFieldsValid && isGroupNameValid
        });
    };

    handleSpaceChange = (event) => {
        this.setState({ selectedSpaceIndex: event.target.value });
    };

    makeReservations = async () => {
        this.setState({
            open: true,
            popupText: 'Please wait we are creating your group reservation...',
            wait: true
        })
        console.log(this.state.camperId)
        let groupIdForReservations
        if (this.state.groupId) {
            groupIdForReservations = this.state.groupId
            console.log("using existing group with id: ", groupIdForReservations)
        } else {
            console.log("creating new group")
            let organizerCamperId
            if (this.state.camperId[0]) {
                organizerCamperId = this.state.camperId[0]
                console.log("using existing camper with id: ", organizerCamperId)
            } else {
                let createNewCamperResponse = await createnewCamper(this.props.user, this.props.serverName, this.state.fname[0], this.state.lname[0], this.state.emailId[0], this.state.phoneNumber[0],
                    this.state.address[0], this.state.city[0], this.state.state[0], this.state.zip[0])
                console.log(createNewCamperResponse)
                organizerCamperId = createNewCamperResponse.body.insertId
                const updatedCamperId = [...this.state.camperId]
                updatedCamperId[0] = organizerCamperId
                this.setState({
                    camperId: updatedCamperId
                });
                console.log("created a new camper with id: ", organizerCamperId)
            }
            let createGroupResponse = await createNewGroup(this.props.user, this.props.serverName, this.state.groupName, this.props.checkIn, this.props.checkOut, organizerCamperId, this.props.spacesSelected.length)
            console.log(createGroupResponse)
            groupIdForReservations = createGroupResponse.body.insertId
        }
        console.log("GroupId for reservation: ", groupIdForReservations)
        console.log("camperId's for reservation: ", this.state.camperId)

        let groupReservationResponse = await createGroupReservations(this.props.user, this.props.serverName, this.state.lname, this.state.fname, this.state.address, this.state.city, this.state.state, this.state.zip, this.state.phoneNumber, this.state.emailId,
            groupIdForReservations, this.state.siteIds, this.props.checkIn, this.props.checkOut, this.state.guests, this.state.pets, this.state.childrens, this.state.subTotal, format(new Date(), 'yyyy-MM-dd HH:mm:ss'), this.state.totalAmount, this.state.camperId, this.props.spacesSelected.length, this.props.discountId, this.state.daySpecificRatesStatus ? 1: 0)
        console.log(groupReservationResponse)
        if(this.state.paymentIntegration.name == 'None'  ||    (this.state.paymentIntegration.name == 'CardConnect' && !this.state.paymentIntegration.cc_merchant_id) || (this.state.paymentIntegration.name.includes('CampPay') && !this.state.paymentIntegration.cp_merchantid)){
            let response2 = await addGroupSystemFeeRecord(this.props.serverName, groupReservationResponse.ids, this.props.checkIn, this.props.checkOut, 'manager', 'created')
        }
        await saveGroupResevationCharges(this.props.user, this.props.serverName, this.state.chargesArray, groupReservationResponse.ids);
        this.setState({
            open: true,
            popupText: 'Reservations created with ids: ' + groupReservationResponse.ids,
            groupIDS: groupReservationResponse.ids,
            wait: false
        })
    }

    render() {
        const { classes } = this.props;
        return (
            <Grid className='reservationList' style={{ width: '100%' }}>
                <ThemeProvider theme={theme} classes={{ paper: classes.dialogPaper }}>
                    <Dialog open={this.state.open} onClose={this.handleCancel}>
                        <DialogTitle>Group Reservation Created</DialogTitle>
                        <DialogContent>
                            {this.state.wait
                                ?
                                <>
                                    {this.state.popupText}
                                </>
                                :
                                <>
                                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                        <thead style={{ backgroundColor: "#f1f2f4", color: "black" }}>
                                            <tr>
                                                <th style={{ textAlign: "left", padding: "10px" }}>Name</th>
                                                <th style={{ textAlign: "left", padding: "10px" }}>Space</th>
                                                <th style={{ textAlign: "left", padding: "10px" }}>Res #</th>
                                                <th style={{ textAlign: "left", padding: "10px" }}>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.props.spacesSelected.map((_, index) => (
                                                <tr key={index}>
                                                    <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>{this.state.fname[index]} {this.state.lname[index]}</td>
                                                    <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>{this.state.spaceName[index]}</td>
                                                    <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>{this.state.groupIDS[index]}</td>
                                                    <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>{this.state.totalAmount[index]}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </>
                            }
                        </DialogContent>
                        {this.state.wait
                            ? null
                            :
                            <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Button onClick={this.handleCancel} style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}>
                                    Close
                                </Button>
                            </DialogActions>
                        }
                    </Dialog>

                    {/* Group Modal */}
                    <Dialog open={this.state.openGroupModal} onClose={() => this.setState({ openGroupModal: false })}>
                        <DialogTitle>Select or Create New Group</DialogTitle>
                        <DialogContent>
                            <Box style={{ display: 'flex', justifyContent: 'space-between', gap: '10%' }}>
                                <Autocomplete
                                    disablePortal
                                    loading={this.state?.groups?.length == 0}
                                    filterOptions={createFilterOptions({
                                        ignoreCase: true,
                                        matchFrom: "start",
                                    })}
                                    onChange={(_, value) => {
                                        if (value) {
                                            this.setState({
                                                groupName: value?.name,
                                                groupId: value?.id,
                                            }, () => {
                                                this.dataValidation();
                                            })
                                        }

                                    }}
                                    options={this.state?.groups && this.state?.groups?.length > 0 ? this.state?.groups.map((i) => ({ ...i, label: i.name, key: i.id })) : []}
                                    sx={{ width: 300 }}
                                    renderInput={(params) => <TextField {...params} label="Search Group" />}
                                />
                                <TextField id="groupName" required label="Group Name" type="text" className='field' value={this.state.groupName} onChange={(event) => this.userDetailsChange(event.target.id, event.target.value, 0)} />
                            </Box>
                        </DialogContent>
                        <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Button onClick={() => this.setState({ openGroupModal: false, groupName: '', groupId: '' })}
                                style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}>
                                Cancel
                            </Button>
                            <Button onClick={() => this.setState({ openGroupModal: false })}
                                style={{ backgroundColor: '#2dcd7a', color: '#000000', padding: '2% 10% 2% 10%', margin: '0 2% 0 0', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}>
                                Save
                            </Button>
                        </DialogActions>
                    </Dialog>
                </ThemeProvider>

                <Box className='scrollContainerUserDetails'>
                    <Box className='box' style={{ marginRight: '0%' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <img src={reservationConfirmation} alt="Reservations" style={{ height: '40px' }} />
                            <Typography className='reservationstypography'>Confirm Reservation</Typography>
                        </div>
                        <div style={{ display: 'flex', width: '45%', justifyContent: 'space-between' }}>
                            <Button startIcon={<ArrowBackIcon />} className='cancel' style={{ marginRight: '2%', backgroundColor: "rgb(153, 153, 153)", color: "#FFF" }} onClick={() => {
                                this.props.backToSelectSpace();
                            }}>Select Space</Button>
                            <Button className='cancel' onClick={() => {
                                this.props.history.replace(`/manager?serverName=${this.props.serverName}&view=reservations`)
                            }}>Cancel Reservation</Button>
                            <Button className='cancel' disabled={!this.state.formValid} onClick={() => { this.makeReservations(); }}
                                style={{
                                    marginRight: '-2%',
                                    backgroundColor: !(this.state.formValid)
                                        ? "#999999"
                                        : "#2dcd7a",
                                    color: "#000000"
                                }} >Complete Reservation</Button>
                        </div>
                    </Box>

                    <Box style={{ display: 'flex', justifyContent: 'left', marginLeft: '2%', marginBottom: '2%' }}>
                        <Button onClick={() => this.setState({ openGroupModal: true })} style={{ backgroundColor: '#2dcd7a', color: '#000000', }}> Select Group</Button>
                        {this.state.groupName != ''
                            ?
                            <Typography style={{ fontSize: '1.5rem', display: 'flex', justifyContent: 'left', marginLeft: '2%' }}> Group Name: {this.state.groupName}</Typography>
                            : null
                        }
                    </Box>

                    <Box className='main'>
                        <Box className='leftRow'>
                            <Box className='userDetails'>
                                <ThemeProvider theme={theme}>
                                    <Box style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center' }}>
                                        <Typography className='typo'>Organizer Details</Typography>
                                        <Box style={{ marginRight: "1%", padding: "4% 3% 0 0" }}>
                                            <Autocomplete
                                                disablePortal
                                                loading={this.state?.allGuests?.length == 0}
                                                filterOptions={createFilterOptions({
                                                    ignoreCase: true,
                                                    matchFrom: "start",
                                                })}
                                                onChange={(_, value) => {
                                                    if (value) {
                                                        this.userDetailsChange("fname", value?.first_name, 0);
                                                        this.userDetailsChange("lname", value?.last_name, 0);
                                                        this.userDetailsChange("emailId", value?.email, 0);
                                                        this.userDetailsChange("phoneNumber", value?.phone, 0);
                                                        this.userDetailsChange("address", value?.address, 0);
                                                        this.userDetailsChange("city", value?.city, 0);
                                                        this.userDetailsChange("state", value?.state, 0);
                                                        this.userDetailsChange("zip", value?.mail_code, 0);
                                                        this.userDetailsChange("camperId", value?.id, 0);
                                                    }
                                                }}
                                                options={this.state?.allGuests && this.state?.allGuests?.length > 0 ? this.state?.allGuests.map((i) => ({ ...i, label: i.first_name + " " + i.last_name, key: i.id })) : []}
                                                sx={{ width: 300 }}
                                                renderInput={(params) => <TextField {...params} label="Search Guest" />}
                                            />
                                        </Box>
                                    </Box>
                                    <hr className='horizontalLine' />
                                    <div className='form-row'>
                                        <TextField id="fname" required label="First Name" type="text" className='field' value={this.state.fname[0] || ''}
                                            InputLabelProps={{ shrink: Boolean(this.state.fname[0]) }} onChange={(event) => this.userDetailsChange(event.target.id, event.target.value, 0)} />
                                        <TextField id="lname" required label="Last Name" type="text" className='field' value={this.state.lname[0] || ''}
                                            InputLabelProps={{ shrink: Boolean(this.state.lname[0]) }} onChange={(event) => this.userDetailsChange(event.target.id, event.target.value, 0)} />
                                    </div>
                                    <div className="form-row-3" style={{ marginBottom: '-0.5%' }}>
                                        <TextField id="guests" required label="Guests" type="text" className="left" value={this.state.guests[0] || ''}
                                            InputLabelProps={{ shrink: Boolean(this.state.guests[0]) }} onChange={(event) => this.userDetailsChange(event.target.id, event.target.value, 0)}
                                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} />
                                        <TextField id="childrens" required label="Childrens" type="text" className="middle" value={this.state.childrens[0] || ''}
                                            InputLabelProps={{ shrink: Boolean(this.state.childrens[0]) }} onChange={(event) => this.userDetailsChange(event.target.id, event.target.value, 0)}
                                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} />
                                        <TextField id="pets" required label="Pets" type="text" className="right" value={this.state.pets[0] || ''}
                                            InputLabelProps={{ shrink: Boolean(this.state.pets[0]) }} onChange={(event) => this.userDetailsChange(event.target.id, event.target.value, 0)}
                                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} />
                                    </div>
                                    <div className='form-row'>
                                        <TextField id="emailId" required label="Email Id" type="email" className='field' value={this.state.emailId[0] || ''}
                                            InputLabelProps={{ shrink: Boolean(this.state.emailId[0]) }} onChange={(event) => this.userDetailsChange(event.target.id, event.target.value, 0)} />
                                        <TextField id="phoneNumber" required label="Phone Number" type="text" className='field' value={this.state.phoneNumber[0] || ''}
                                            InputLabelProps={{ shrink: Boolean(this.state.phoneNumber[0]) }} onChange={(event) => this.userDetailsChange(event.target.id, event.target.value, 0)}
                                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                        />
                                    </div>
                                    <div className='form-row-2'>
                                        <TextField id="address" required label="Address" type="text" className='full-width' value={this.state.address[0]}
                                            InputLabelProps={{ shrink: Boolean(this.state.address[0]) }} onChange={(event) => this.userDetailsChange(event.target.id, event.target.value, 0)} />
                                    </div>
                                    <div className='form-row-3'>
                                        <TextField id="city" required label="City" type="text" className='left' value={this.state.city[0] || ''}
                                            InputLabelProps={{ shrink: Boolean(this.state.city[0]) }} onChange={(event) => this.userDetailsChange(event.target.id, event.target.value, 0)} />
                                        <TextField id="state" required label="State" type="text" className='middle' value={this.state.state[0] || ''}
                                            InputLabelProps={{ shrink: Boolean(this.state.state[0]) }} onChange={(event) => this.userDetailsChange(event.target.id, event.target.value, 0)} />
                                        <TextField id="zip" required label="Postal Code" type="text" className='right' value={this.state.zip[0] || ''}
                                            InputLabelProps={{ shrink: Boolean(this.state.zip[0]) }} onChange={(event) => this.userDetailsChange(event.target.id, event.target.value, 0)} />
                                    </div>
                                </ThemeProvider>
                            </Box>
                        </Box>
                        <Box className='rightRow'>
                            <Box className='bookingDetails' style={{ marginBottom: '7%' }}>
                                <Typography className='bookingTypo'>Booking Details (Site: {this.props.spacesSelected[0].spaceName})</Typography>
                                <hr className='horizontalLine' />
                                <Box className='bookingRow'>
                                    <Box>
                                        <DateRangeIcon />
                                        <Typography className='bookingLabel'>{this.props.checkIn}</Typography>
                                    </Box>
                                    <TrendingFlatIcon />
                                    <Box className='checkout'>
                                        <DateRangeIcon />
                                        <Typography className='bookingValue'>{this.props.checkOut}</Typography>
                                    </Box>
                                </Box>
                                <Box className='bookingRow'>
                                    <Box>
                                        <GroupIcon />
                                        <Typography className='bookingLabel'>Guests</Typography>
                                    </Box>
                                    <Typography className='bookingValue'>{this.state.guests[0]}</Typography>
                                </Box>
                                <Box className="bookingRow">
                                    <Box>
                                        <GroupIcon />
                                        <Typography className="bookingLabel">Childrens</Typography>
                                    </Box>
                                    <Typography className="bookingValue">{this.state.childrens[0]}</Typography>
                                </Box>
                                <Box className="bookingRow">
                                    <Box>
                                        <PetsIcon />
                                        <Typography className="bookingLabel">Pets</Typography>
                                    </Box>
                                    <Typography className="bookingValue">{this.state.pets[0]}</Typography>
                                </Box>
                                <hr className='horizontalLine' />
                                <Box className='bookingRow'>
                                    <Typography className='bookingLabel'>Site Name</Typography>
                                    <Typography className='bookingValue'>{this.props.spacesSelected[0].spaceName}</Typography>
                                </Box>
                                <Box className='bookingRow'>
                                    <Typography className='bookingLabel'>Site Type</Typography>
                                    <Typography className='bookingValue'>{this.props.spacesSelected[0].siteType}</Typography>
                                </Box>
                                {this.state.months > 0
                                    ? <Box className='bookingRow'>
                                        <Typography className='bookingLabel'>Months Total ({this.state.months})</Typography>
                                        <Typography className='bookingValue'>${parseFloat(this.state.monthsTotal[0]).toFixed(2)}</Typography>
                                    </Box>
                                    : null
                                }
                                {this.state.weeks > 0
                                    ? <Box className='bookingRow'>
                                        <Typography className='bookingLabel'>Weeks Total ({this.state.weeks})</Typography>
                                        <Typography className='bookingValue'>${parseFloat(this.state.weeksTotal[0]).toFixed(2)}</Typography>
                                    </Box>
                                    : null
                                }
                                {this.state.days > 0
                                    ? <Box className='bookingRow'>
                                        <Typography className='bookingLabel'>Days Total ({this.state.days})</Typography>
                                        <Typography className='bookingValue'>${parseFloat(this.state.daysTotal[0]).toFixed(2)}</Typography>
                                    </Box>
                                    : null
                                }
                                {this.state.discountTotal.length
                                    ? <Box className='bookingRow'>
                                        {this.state.discountByPercent
                                            ?
                                            <Typography className='bookingLabel'>{this.props.discountName?`Discount: ${this.props.discountName}`:'Discount'} ({this.props.discountPercent}%)</Typography>
                                            :
                                            <Typography className='bookingLabel'>{this.props.discountName?`Discount: ${this.props.discountName}`:'Discount'} </Typography>
                                        }
                                        <Typography className='bookingValue'>${parseFloat(this.state.discountTotal[0]??0).toFixed(2)}</Typography>
                                        </Box> : null
                                }
                                <hr className='horizontalLine' />
                                <Box className='bookingRow'>
                                    <Typography className='bookingLabel' style={{ fontWeight: 'bold' }}>Sub Total</Typography>
                                    <Typography className='bookingValue' style={{ fontWeight: 'bold' }}>${parseFloat(this.state.subTotal[0]).toFixed(2)}</Typography>
                                </Box>
                                <hr className='horizontalLine' />
                                {this.state.taxName[0] && Array.isArray(this.state.taxName[0]) &&
                                    this.state.taxName[0].map((taxName, taxIndex) => (
                                        <Box className='bookingRow' key={taxIndex}>
                                            <Typography className='bookingLabel'>
                                                {taxName} ({this.state.taxPercent[0][taxIndex]}%)
                                            </Typography>
                                            <Typography className='bookingValue'>
                                                ${parseFloat(this.state.tax[0][taxIndex]).toFixed(2)}
                                            </Typography>
                                        </Box>
                                    ))
                                }
                                <hr className='horizontalLine' />

                                <Box className='bookingRow'>
                                    <Typography className='bookingLabel' style={{ fontWeight: 'bold' }}>Total</Typography>
                                    <Typography className='bookingValue' style={{ fontWeight: 'bold' }}>${parseFloat(this.state.totalAmount[0]).toFixed(2)}</Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Box>

                    <Box className="container">
                        <Box className="main">
                            <Box className="leftRow">
                                <Box className="userDetails">
                                    <ThemeProvider theme={theme}>
                                        <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <Typography className="typo">Guest Details</Typography>
                                            <Box style={{ marginRight: "1%", padding: "4% 3% 0 0" }}>
                                                <Autocomplete
                                                    disablePortal
                                                    loading={this.state?.allGuests?.length == 0}
                                                    filterOptions={createFilterOptions({
                                                        ignoreCase: true,
                                                        matchFrom: "start",
                                                    })}
                                                    value={
                                                        this.state.allGuests.find(
                                                        (guest) =>
                                                            guest.id === this.state.camperId[this.state.selectedSpaceIndex]
                                                        ) || null
                                                    }
                                                    onChange={(_, value) => {
                                                        if (value) {
                                                            this.userDetailsChange("fname", value?.first_name, this.state.selectedSpaceIndex);
                                                            this.userDetailsChange("lname", value?.last_name, this.state.selectedSpaceIndex);
                                                            this.userDetailsChange("emailId", value?.email, this.state.selectedSpaceIndex);
                                                            this.userDetailsChange("phoneNumber", value?.phone, this.state.selectedSpaceIndex);
                                                            this.userDetailsChange("address", value?.address, this.state.selectedSpaceIndex);
                                                            this.userDetailsChange("city", value?.city, this.state.selectedSpaceIndex);
                                                            this.userDetailsChange("state", value?.state, this.state.selectedSpaceIndex);
                                                            this.userDetailsChange("zip", value?.mail_code, this.state.selectedSpaceIndex);
                                                            this.userDetailsChange("camperId", value?.id, this.state.selectedSpaceIndex);
                                                        }
                                                    }}
                                                    options={this.state?.allGuests?.map((i) => ({
                                                        ...i,
                                                        label: `${i.first_name} ${i.last_name}`,
                                                        key: i.id,
                                                    }))}
                                                    getOptionLabel={(option) =>
                                                        option && option.first_name && option.last_name
                                                        ? `${option.first_name} ${option.last_name}`
                                                        : ""
                                                    }
                                                    // 🔹 Helps MUI match by ID
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    sx={{ width: 300 }}
                                                    renderInput={(params) => <TextField {...params} label="Search Guest" />}
                                                />
                                            </Box>
                                        </Box>
                                        <hr className="horizontalLine" />
                                        <div className="form-row" style={{ marginLeft: '3%' }}>
                                            <Typography style={{marginRight: '3%', fontSize:'1rem'}}> Choose a site: </Typography>
                                            <Select
                                                value={this.state.selectedSpaceIndex}
                                                onChange={this.handleSpaceChange}
                                                style={{ width: "100px" }}
                                            >
                                                {this.props.spacesSelected.slice(1).map((space, index) => (
                                                    <MenuItem value={index + 1} key={space.spaceName}>
                                                        {space.spaceName}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </div>
                                        <div className="form-row">
                                            <TextField id="fname" required label="First Name" type="text" className="field" value={this.state.fname[this.state.selectedSpaceIndex]}
                                                onChange={(event) => this.userDetailsChange(event.target.id, event.target.value, this.state.selectedSpaceIndex)}
                                                InputLabelProps={{ shrink: Boolean(this.state.fname[this.state.selectedSpaceIndex]) }} />
                                            <TextField id="lname" required label="Last Name" type="text" className="field" value={this.state.lname[this.state.selectedSpaceIndex]}
                                                onChange={(event) => this.userDetailsChange(event.target.id, event.target.value, this.state.selectedSpaceIndex)}
                                                InputLabelProps={{ shrink: Boolean(this.state.lname[this.state.selectedSpaceIndex]) }} />
                                        </div>
                                        <div className="form-row-3" style={{ marginBottom: '-0.5%' }}>
                                            <TextField id="guests" required label="Guests" type="text" className="left" value={this.state.guests[this.state.selectedSpaceIndex]}
                                                onChange={(event) => this.userDetailsChange(event.target.id, event.target.value, this.state.selectedSpaceIndex)}
                                                InputLabelProps={{ shrink: Boolean(this.state.guests[this.state.selectedSpaceIndex]) }} />
                                            <TextField id="childrens" required label="Childrens" type="text" className="middle" value={this.state.childrens[this.state.selectedSpaceIndex]}
                                                onChange={(event) => this.userDetailsChange(event.target.id, event.target.value, this.state.selectedSpaceIndex)}
                                                InputLabelProps={{ shrink: Boolean(this.state.childrens[this.state.selectedSpaceIndex]) }} />
                                            <TextField id="pets" required label="Pets" type="text" className="right" value={this.state.pets[this.state.selectedSpaceIndex]}
                                                onChange={(event) => this.userDetailsChange(event.target.id, event.target.value, this.state.selectedSpaceIndex)}
                                                InputLabelProps={{ shrink: Boolean(this.state.pets[this.state.selectedSpaceIndex]) }} />
                                        </div>
                                        <div className="form-row">
                                            <TextField id="emailId" label="Email Id" type="email" className="field" value={this.state.emailId[this.state.selectedSpaceIndex]}
                                                onChange={(event) => this.userDetailsChange(event.target.id, event.target.value, this.state.selectedSpaceIndex)}
                                                InputLabelProps={{ shrink: Boolean(this.state.emailId[this.state.selectedSpaceIndex]) }} />
                                            <TextField id="phoneNumber" label="Phone Number" type="text" className="field" value={this.state.phoneNumber[this.state.selectedSpaceIndex]}
                                                onChange={(event) => this.userDetailsChange(event.target.id, event.target.value, this.state.selectedSpaceIndex)}
                                                InputLabelProps={{ shrink: Boolean(this.state.phoneNumber[this.state.selectedSpaceIndex]) }} inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                                            />
                                        </div>
                                        <div className="form-row-2">
                                            <TextField id="address" label="Address" type="text" className="full-width" value={this.state.address[this.state.selectedSpaceIndex]}
                                                onChange={(event) => this.userDetailsChange(event.target.id, event.target.value, this.state.selectedSpaceIndex)}
                                                InputLabelProps={{ shrink: Boolean(this.state.address[this.state.selectedSpaceIndex]) }} />
                                        </div>
                                        <div className="form-row-3">
                                            <TextField id="city" label="City" type="text" className="left" value={this.state.city[this.state.selectedSpaceIndex]}
                                                onChange={(event) => this.userDetailsChange(event.target.id, event.target.value, this.state.selectedSpaceIndex)}
                                                InputLabelProps={{ shrink: Boolean(this.state.city[this.state.selectedSpaceIndex]) }} />
                                            <TextField id="state" label="State" type="text" className="middle" value={this.state.state[this.state.selectedSpaceIndex]}
                                                onChange={(event) => this.userDetailsChange(event.target.id, event.target.value, this.state.selectedSpaceIndex)}
                                                InputLabelProps={{ shrink: Boolean(this.state.state[this.state.selectedSpaceIndex]) }} />
                                            <TextField id="zip" label="Postal Code" type="text" className="right" value={this.state.zip[this.state.selectedSpaceIndex]}
                                                onChange={(event) => this.userDetailsChange(event.target.id, event.target.value, this.state.selectedSpaceIndex)}
                                                InputLabelProps={{ shrink: Boolean(this.state.zip[this.state.selectedSpaceIndex]) }} />
                                        </div>
                                    </ThemeProvider>
                                </Box>
                            </Box>
                            <Box className="rightRow">
                                <Box className="bookingDetails" style={{ marginBottom: "7%" }}>
                                    <Typography className="bookingTypo">Booking Details (Site: {this.props.spacesSelected[this.state.selectedSpaceIndex].spaceName})</Typography>
                                    <hr className="horizontalLine" />
                                    <Box className="bookingRow">
                                        <Box>
                                            <DateRangeIcon />
                                            <Typography className="bookingLabel">{this.props.checkIn}</Typography>
                                        </Box>
                                        <TrendingFlatIcon />
                                        <Box className="checkout">
                                            <DateRangeIcon />
                                            <Typography className="bookingValue">{this.props.checkOut}</Typography>
                                        </Box>
                                    </Box>
                                    <Box className="bookingRow">
                                        <Box>
                                            <GroupIcon />
                                            <Typography className="bookingLabel">Guests</Typography>
                                        </Box>
                                        <Typography className="bookingValue">{this.state.guests[this.state.selectedSpaceIndex]}</Typography>
                                    </Box>
                                    <Box className="bookingRow">
                                        <Box>
                                            <GroupIcon />
                                            <Typography className="bookingLabel">Childrens</Typography>
                                        </Box>
                                        <Typography className="bookingValue">{this.state.childrens[this.state.selectedSpaceIndex]}</Typography>
                                    </Box>
                                    <Box className="bookingRow">
                                        <Box>
                                            <PetsIcon />
                                            <Typography className="bookingLabel">Pets</Typography>
                                        </Box>
                                        <Typography className="bookingValue">{this.state.pets[this.state.selectedSpaceIndex]}</Typography>
                                    </Box>
                                    <hr className="horizontalLine" />
                                    <Box className="bookingRow">
                                        <Typography className="bookingLabel">Site Name</Typography>
                                        <Typography className="bookingValue">{this.props.spacesSelected[this.state.selectedSpaceIndex].spaceName}</Typography>
                                    </Box>
                                    <Box className="bookingRow">
                                        <Typography className="bookingLabel">Site Type</Typography>
                                        <Typography className="bookingValue">{this.props.spacesSelected[this.state.selectedSpaceIndex].siteType}</Typography>
                                    </Box>
                                    {this.state.months > 0 && (
                                        <Box className="bookingRow">
                                            <Typography className="bookingLabel">Months Total ({this.state.months})</Typography>
                                            <Typography className="bookingValue">${parseFloat(this.state.monthsTotal[this.state.selectedSpaceIndex]).toFixed(2)}</Typography>
                                        </Box>
                                    )}
                                    {this.state.weeks > 0 && (
                                        <Box className="bookingRow">
                                            <Typography className="bookingLabel">Weeks Total ({this.state.weeks})</Typography>
                                            <Typography className="bookingValue">${parseFloat(this.state.weeksTotal[this.state.selectedSpaceIndex]).toFixed(2)}</Typography>
                                        </Box>
                                    )}
                                    {this.state.days > 0 && (
                                        <Box className="bookingRow">
                                            <Typography className="bookingLabel">Days Total ({this.state.days})</Typography>
                                            <Typography className="bookingValue">${parseFloat(this.state.daysTotal[this.state.selectedSpaceIndex]).toFixed(2)}</Typography>
                                        </Box>
                                    )}
                                    {this.state.discountTotal.length
                                    ? <Box className='bookingRow'>
                                        {this.state.discountByPercent
                                            ?
                                            <Typography className='bookingLabel'>{this.props.discountName?`Discount: ${this.props.discountName}`:'Discount'} ({this.props.discountPercent}%)</Typography>
                                            :
                                            <Typography className='bookingLabel'>{this.props.discountName?`Discount: ${this.props.discountName}`:'Discount'} </Typography>
                                        }
                                        <Typography className='bookingValue'>${parseFloat(this.state.discountTotal[this.state.selectedSpaceIndex]??0).toFixed(2)}</Typography>
                                        </Box> : null
                                    }
                                    <hr className="horizontalLine" />
                                    <Box className="bookingRow">
                                        <Typography className="bookingLabel" style={{ fontWeight: "bold" }}>Sub Total</Typography>
                                        <Typography className="bookingValue" style={{ fontWeight: "bold" }}>${parseFloat(this.state.subTotal[this.state.selectedSpaceIndex]).toFixed(2)}</Typography>
                                    </Box>
                                    <hr className="horizontalLine" />
                                    {this.state.taxName[this.state.selectedSpaceIndex] &&
                                        Array.isArray(this.state.taxName[this.state.selectedSpaceIndex]) &&
                                        this.state.taxName[this.state.selectedSpaceIndex].map((taxName, taxIndex) => (
                                            <Box className="bookingRow" key={taxIndex}>
                                                <Typography className="bookingLabel">
                                                    {taxName} ({this.state.taxPercent[this.state.selectedSpaceIndex][taxIndex]}%)
                                                </Typography>
                                                <Typography className="bookingValue">
                                                    ${parseFloat(this.state.tax[this.state.selectedSpaceIndex][taxIndex]).toFixed(2)}
                                                </Typography>
                                            </Box>
                                        ))}
                                    <hr className="horizontalLine" />
                                    <Box className="bookingRow">
                                        <Typography className="bookingLabel" style={{ fontWeight: "bold" }}>Total</Typography>
                                        <Typography className="bookingValue" style={{ fontWeight: "bold" }}>${parseFloat(this.state.totalAmount[this.state.selectedSpaceIndex]).toFixed(2)}</Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Grid>
        )
    };
};
export default withRouter(withStyles(useStyles)(GroupReservationUserDetails));